import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Layout from '../components/Layout/Layout';
import Hero from '../components/Screens/Hero';
import Main from '../components/Screens/Main';
import Section from '../components/Screens/Section';
import Spotlight from '../components/Screens/Spotlight';
import Link from '../components/Global/Link';
import Markdown from '../components/Richtext/Markdown';
import CardNews from '../components/Cards/CardNews';
import Modal from '../components/Modal/Modal';
import Video from '../utils/Vimeo';

// ====

const Index = (props) => {
  const { data, blok } = props;
  let pageData;
  let newsData;
  if (data) {
    pageData = JSON.parse(data.index.content);
    newsData = data.news.nodes;
  } else {
    pageData = blok;
    newsData = blok;
  }
  const openGraph = {
    type: 'website',
    title: 'Home',
  };

  const [fullVideo, setFullVideo] = useState(false);

  function closeModal() {
    setFullVideo(false);
  }

  return (
    <Layout
      meta={pageData.meta}
      openGraph={openGraph}
      image={pageData.placeholder_image}
      background="black"
      video={pageData.vimeo}
      size="home"
      pauseVideo={fullVideo}
    >
      <Hero size="home" video={() => setFullVideo(!fullVideo)} />
      {fullVideo && (
        <Modal closeFunction={closeModal} size="full">
          <Video source={pageData.vimeo} controls autopause={false} />
        </Modal>
      )}
      <Main>
        <Section marginBottom>
          <div className="col-12 col-md-6 brand-col">
            <div className="card brand-background-blue h-100">
              <div className="card-body pb-0">
                <h3 className="brand-font-caps">
                  <span className="brand-font-outline">01</span> Our Story
                </h3>
                <Markdown>{pageData.content_card_a_copy}</Markdown>
              </div>
              <div className="card-footer text-right m-0 pt-0 brand-background-transparent border-0">
                <Link
                  icon
                  font
                  stretched
                  className="brand-link-no-decoration"
                  to="/our-story/"
                >
                  Read more
                </Link>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 brand-col">
            <div className="card brand-background-pink h-100">
              <div className="card-body">
                <h3 className="brand-font-caps">
                  <span className="brand-font-outline">02</span> Our People
                </h3>
                <Markdown>{pageData.content_card_b_copy}</Markdown>
              </div>
              <div className="card-footer text-right m-0 pt-0 brand-background-transparent border-0">
                <Link
                  icon
                  font
                  stretched
                  className="brand-link-no-decoration"
                  to="/our-people/"
                >
                  Read more
                </Link>
              </div>
            </div>
          </div>
        </Section>

        {blok && (
          <Section className="brand-background-white p-5">
            Game spotlight and latest news appear here
          </Section>
        )}

        {pageData.game_spotlight && !blok && (
          <Spotlight
            label="Game spotlight"
            title={pageData.game_spotlight.content.game_title}
            description={pageData.game_spotlight.content.short_description}
            link={pageData.game_spotlight.slug}
            backgroundImage={pageData.game_spotlight.content.game_bg_image}
            marginBottom
          />
        )}

        {pageData.latest_news && !blok && (
          <Section marginBottom>
            {newsData.map((node) => {
              const item = JSON.parse(node.content);
              return (
                <CardNews
                  title={item.article_title}
                  image={item.thumbnail_image}
                  category={item.category}
                  date={item.published_date}
                  copy={item.opening_copy}
                  link={node.slug}
                />
              );
            })}
          </Section>
        )}

        {pageData.recruitment_message_title &&
          pageData.recruitment_message_copy && (
            <Section fullWidth className="brand-background-yellow">
              <div className="col-12 col-md-12 brand-col text-center">
                <div className="p-5">
                  <h2 className="brand-font brand-headline brand-headline-massive brand-headline-hero mx-auto">
                    <Markdown>{pageData.recruitment_message_title}</Markdown>
                  </h2>
                  <Markdown>{pageData.recruitment_message_copy}</Markdown>
                  <Link button icon stretched to="/careers/">
                    See open roles
                  </Link>
                </div>
              </div>
            </Section>
          )}
      </Main>
    </Layout>
  );
};

export default Index;

// ====

export const QUERY = graphql`
  query HomeDefaultQuery {
    index: storyblokEntry(slug: { eq: "homepage" }) {
      content
    }

    # Grab news articles
    news: allStoryblokEntry(
      filter: { parent_id: { eq: 11989046 } }
      limit: 2
      sort: { fields: field_published_date_string, order: DESC }
    ) {
      nodes {
        name
        slug
        field_published_date_string
        content
      }
    }
  }
`;

Index.propTypes = {
  data: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  blok: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Index.defaultProps = {
  data: null,
  blok: null,
};
